import { Grid, Typography } from '@mui/material';
import { ICON_MAP } from '../IconLibrary/IconLibraryMap';
import { IconLibrary } from '../IconLibrary/IconLibrary';
import { FlexContainer } from '../../containers/ContentContainers/FlexContainer';

export type IconMessageProps = {
  message: string;
  subMessage?: string;
  iconName?: keyof typeof ICON_MAP;
  iconColor?: string;
};

export const IconMessage = ({
  message,
  subMessage,
  iconName,
  iconColor,
}: IconMessageProps) => {
  return (
    <FlexContainer
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid container justifyContent="center">
        <IconLibrary iconName={iconName} size={96} color={iconColor} />
      </Grid>
      <Grid container justifyContent="center">
        <Typography variant="titleMedium" color="text.primary">
          {message}
        </Typography>
      </Grid>
      {!!subMessage && (
        <Grid container justifyContent="center" sx={{ marginTop: '8px' }}>
          <Typography variant="bodyMedium">{subMessage}</Typography>
        </Grid>
      )}
    </FlexContainer>
  );
};
